import React from "react";
import type { CSSProperties } from "react";
import "./styles.css";

interface LoadingStyles {
  readonly root?: CSSProperties;
  readonly dot?: CSSProperties;
}

interface LoadingProps {
  readonly color?: string;
  readonly duration?: number;
  readonly size?: number;
  readonly styles?: LoadingStyles;
}

const getColorValue = (color?: string): string => {
  if (!color) {
    return "#9e9e9e";
  }

  const colorMap: Record<string, string> = {
    gray: "#9e9e9e",
    grey: "#9e9e9e",
  };

  return colorMap[color] || color;
};

const Loading = ({
  color = "grey",
  duration = 550,
  size = 1,
  styles = {},
}: LoadingProps) => {
  const numericSize = Number(size);

  const dotSize = Number.isFinite(numericSize)
    ? Math.max(numericSize, 0) / 2
    : 0.5;

  const rootStyle: CSSProperties = {
    "--c11n-loading-dot-size": `${dotSize}rem`,
    "--c11n-loading-dot-margin": `0 ${dotSize / 3}rem`,
    "--c11n-loading-color": getColorValue(color),
    "--c11n-loading-duration": `${duration}ms`,
    ...styles.root,
  } as CSSProperties;

  return (
    <div className="c11n-loading" style={rootStyle}>
      <span className="c11n-loading-dot" style={styles.dot} />
      <span className="c11n-loading-dot" style={styles.dot} />
      <span className="c11n-loading-dot" style={styles.dot} />
    </div>
  );
};

export default Loading;
